export const FAQ_DETAILS_SEGMENT = "faq-details";

export const faqDetailsPath = (code) =>
  `${window.contextPath}/faq/${FAQ_DETAILS_SEGMENT}?code=${encodeURIComponent(code)}`;
